import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-start;

  color: ${(props) => props.theme.colors.textPrimary};

  @media (min-width: 800px) {
    justify-content: center;
  }

  .tablePedidos:not(td) {
    background-color: #e6f7ff !important;
  }
`;
